import styled from 'styled-components';

export const DashboardContainer = styled.div`
  padding: 32px;
  max-width: 1200px;
  margin: 0 auto;
  font-family: 'Courier New', monospace;
`;

export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
`;

export const Title = styled.h1`
  font-size: 2rem;
  color: #333;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  font-weight: normal;
  font-family: 'Courier New', monospace;
`;

export const TabsContainer = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 32px;
  border-bottom: 1px solid #000;
`;

export const Tab = styled.button`
  padding: 12px 24px;
  background: ${props => props.active === 'true' ? '#000' : 'transparent'};
  color: ${props => props.active === 'true' ? '#fff' : '#000'};
  border: none;
  cursor: pointer;
  font-family: 'Courier New', monospace;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  font-size: 0.9rem;
  transition: all 0.3s ease;

  &:hover {
    background: ${props => props.active === 'true' ? '#000' : '#f0f0f0'};
  }
`;

export const Button = styled.button`
  padding: 12px 24px;
  background: #c41e3a;
  color: white;
  border: none;
  border-radius: 0;
  cursor: pointer;
  transition: background 0.3s ease;
  font-family: 'Courier New', monospace;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  font-size: 0.9rem;

  &:hover {
    background: #a01830;
  }
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  font-size: 0.9rem;
  letter-spacing: 0.05em;
  font-family: 'Courier New', monospace;
`;

export const Th = styled.th`
  text-align: left;
  padding: 16px;
  background: #f5f5f5;
  border-bottom: 2px solid #000;
  text-transform: uppercase;
  font-weight: normal;
  letter-spacing: 0.1em;
  font-family: 'Courier New', monospace;
`;

export const Td = styled.td`
  padding: 16px;
  border-bottom: 1px solid #ddd;
  font-family: 'Courier New', monospace;
`;

export const ActionButton = styled.button`
  padding: 8px 16px;
  margin-right: 8px;
  border: none;
  border-radius: 0;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: 'Courier New', monospace;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  font-size: 0.8rem;

  ${props => props.edit && `
    background: #4CAF50;
    color: white;
    &:hover {
      background: #45a049;
    }
  `}

  ${props => props.delete && `
    background: #f44336;
    color: white;
    &:hover {
      background: #da190b;
    }
  `}
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`; 